import { useLocation, useNavigate } from 'react-router-dom';

export const useRedirects = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const path = location.pathname;
  const hash = location.hash;
  const query = location.search;
  const pathWithQuery = path + query;

  if (path === '/') {
    if (hash === '#employee') {
      navigate(`/employee/events${query}`);
    }

    if (hash === '#company') {
      navigate(`/company/events${query}`);
    }
  }

  if (path.startsWith('/events')) {
    if (hash === '#company') {
      navigate(`/company${pathWithQuery}`);
    }

    if (hash === '#employee' || hash === '') {
      navigate(`/employee${pathWithQuery}`);
    }
  }

  if (path.startsWith('/candidates')) {
    navigate(`/company${pathWithQuery}`);
  }

  if (path.startsWith('/company/organization')) {
    navigate(`/organization${query}`);
  }

  if (path.startsWith('/policy')) {
    if (path === '/policy' && (hash === '' || hash === '#employee')) {
      navigate(`/employee/policy${query}`);
    } else {
      navigate(`/company${pathWithQuery}`);
    }
  }

  if (path.startsWith('/vacation')) {
    if (hash === '' || hash === '#employee') {
      navigate(`/employee${pathWithQuery}`);
    }

    if (hash === '#company') {
      navigate(`/company${pathWithQuery}`);
    }
  }
};
